'use client'

import type { FaqItem } from '@/types/solution'
import { motion } from 'framer-motion'
import { FaqAccordion } from '@/components/feature/ui/faq-accordion'
import { cn } from '@/lib/utils'

interface FAQSectionProps {
  title: string
  sub_title: string
  faqs: FaqItem[]
  className?: string
}

export function FAQSection({
  title,
  sub_title,
  faqs,
  className,
}: FAQSectionProps) {
  return (
    <section className={cn('py-12 sm:py-16', className)}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-5xl font-bold tracking-tight text-white mb-4">
            {title}
          </h2>
          <p className="mt-4 text-lg text-gray-400">{sub_title}</p>
        </motion.div>

        <div className="w-full">
          <FaqAccordion
            data={faqs.map((q, idx) => ({
              ...q,
              id: idx, // Ensure a unique id for the accordion
            }))}
          />
        </div>
      </div>
    </section>
  )
}
